import React from "react";

function LearnerGridRight(props) {
    return <div className="learner-grid__right">{props.children}</div>;
}

export default LearnerGridRight;